import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import CustomInput from "../../../Common/CustomInput";
import { Checkbox, Radio, Typography } from "antd";
import { questionInputType } from "../../../../utils/surveys";

const OpenTextQuestionItem = ({ questionIndex, questionName }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            <Controller
                control={control}
                name={`${questionName}.placeholder`}
                render={({ field }) => (
                    <CustomInput
                        errors={errors}
                        label="Placeholder"
                        {...field}
                    />
                )}
            />
            <Controller
                control={control}
                name={`${questionName}.longAnswer`}
                render={({ field }) => (
                    <Checkbox checked={!!field.value} {...field}>
                        Long Answer
                    </Checkbox>
                )}
            />
            <Controller
                control={control}
                name={`${questionName}.inputType`}
                render={({ field }) => (
                    <div>
                        <Typography.Title level={5}>
                            Input type
                        </Typography.Title>
                        <Radio.Group {...field}>
                            {questionInputType.map((inputType) => (
                                <Radio.Button
                                    key={inputType.value}
                                    value={inputType.value}
                                >
                                    {inputType.label}
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    </div>
                )}
            />
        </div>
    );
};

export default OpenTextQuestionItem;
